import { observer } from 'mobx-react';

import './styles.scss';
import { useDashboardDict } from './../../../../../../context/useDashboardDict';
import { formatValueWithUnits } from './../../../../../../utilities/formatValueWithUnits';

type PropsType = {
   labels: Record<string, string>
   items: any[]
};

export const PPDWidgetProductGroupsPricesList = observer(({ labels, items = [] }: PropsType) => {
    const { assortment, units } = useDashboardDict();

    return (
        <ul className="ppd-widget-product-groups-prices-list">
            {items.map((item) => {
                const group = assortment?.find(a => a.id === item.assortment_id);
                if (!group) return null;

                return (
                    <li
                        key={item.assortment_id}
                        className="ppd-widget-product-groups-prices-list__item"
                    >
                        <div className="ppd-widget-product-groups-prices-list__item-header">
                            <div className="ppd-widget-product-groups-prices-list__category">
                                {group.name}
                            </div>
                            <div
                                className={`ppd-widget-product-groups-prices-list__badge ppd-widget-product-groups-prices-list__badge--${item.status}`}
                            >
                                <span className="ppd-widget-product-groups-prices-list__badge-text">
                                    {labels[item.status as keyof typeof labels]}
                                </span>
                            </div>
                        </div>

                        <div className="ppd-widget-product-groups-prices-list__item-content">
                            <div className="ppd-widget-product-groups-prices-list__metric">
                                <div className="ppd-widget-product-groups-prices-list__metric-label">
                                    {labels.plan}
                                </div>
                                <div className="ppd-widget-product-groups-prices-list__metric-value">
                                    {formatValueWithUnits(item.plan, units) ? formatValueWithUnits(item.plan, units) : "-"}
                                </div>
                            </div>

                            <div className="ppd-widget-product-groups-prices-list__metric">
                                <div className="ppd-widget-product-groups-prices-list__metric-label">
                                    {labels.fact}
                                </div>
                                <div
                                    className={`ppd-widget-product-groups-prices-list__metric-value ppd-widget-product-groups-prices-list__metric-value--${item.status}`}
                                >
                                    {formatValueWithUnits(item.fact, units) ? formatValueWithUnits(item.fact, units) : "-"}
                                </div>
                            </div>
                        </div>
                    </li>
                );
            })}
        </ul>
    );
});
